// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================================================
   Create Blog — styled to match create-flow (upload-dialog shell)
   ============================================================ */
.upload-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.upload-dialog {
  width: 90%;
  max-width: 980px;
  height: 90vh;
  max-height: 90vh;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: auto;
  z-index: 10000;
}

.upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #fff;
  color: #111827;
  border-bottom: 1px solid #e4e8f0;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.icon-circle {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.icon-circle mat-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.header-copy {
  min-width: 0;
}
.header-copy .title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  font-family: "Raleway", sans-serif;
}
.header-copy span {
  font-size: 14px;
  color: #6b7280;
}

.icon-button {
  border: none;
  background: #f3f4f6;
  color: inherit;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.icon-button mat-icon {
  font-size: 22px;
}
.icon-button:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

.stage-banner {
  padding: 1px 16px 8px;
  background: #fff;
  border-bottom: 1px solid #edf1f7;
  flex-shrink: 0;
}

.journey-progress {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 16px 0 8px;
  margin-top: 4px;
  flex-shrink: 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  width: 100%;
  position: relative;
}

.journey-step {
  background: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  min-width: auto;
  flex-shrink: 0;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.2s ease;
  white-space: nowrap;
  align-self: center;
  padding: 0;
}
.journey-step:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.journey-step.active {
  color: #5ea1d8;
}
.journey-step.active .step-label {
  border-color: #5ea1d8;
  background: rgba(94, 161, 216, 0.1);
  color: #5ea1d8;
}

.journey-step.complete {
  color: #16a34a;
}
.journey-step.complete .step-label {
  border-color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.step-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1.2;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 8px 16px;
  border-radius: 35px;
  border: 2px solid currentColor;
  background: transparent;
  flex-shrink: 0;
  font-family: "Raleway", sans-serif;
}
.step-label .step-count,
.step-label .label-text {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.step-label.complete {
  border-color: #16a34a;
  color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
}
.step-label .label-check {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-left: 0.15rem;
}

.step-connector {
  flex: 1;
  min-width: 20px;
  height: 2px;
  background: #e5e7eb;
  flex-shrink: 1;
  align-self: center;
  margin: 0 4px;
  position: relative;
  z-index: 0;
}

.step-connector.fill {
  background: #16a34a;
}

.upload-body {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 10px;
  background: #fdfdff;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  flex: 1 1 auto;
}
.upload-body::-webkit-scrollbar {
  width: 8px;
}
.upload-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.upload-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.upload-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.primary-pane {
  flex: 1 1 100%;
  min-width: 0;
}
.primary-pane.full-width {
  width: 100%;
}

.section-card.journey-card {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e4e8f0;
  overflow: hidden;
  min-height: 100%;
}

.journey-content {
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 0;
  min-height: 0;
}

.journey-pane-header {
  margin-bottom: 16px;
}
.journey-pane-header h3 {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  font-family: "Raleway", sans-serif;
}

.helper-text {
  margin: 0;
  color: #5f6368;
  font-size: 14px;
  line-height: 1.45;
}

.upload-footer {
  padding: 16px 24px;
  border-top: 1px solid #e4e8f0;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.05);
  flex-shrink: 0;
}
.upload-footer .footer-step {
  flex: 0 0 auto;
}

.footer-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  flex: 1 1 auto;
}

.footer-btn {
  border-radius: 999px;
  border: 1px solid transparent;
  padding: 10px 24px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
  font-family: "Raleway", sans-serif;
}
.footer-btn.primary {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}
.footer-btn.primary:hover:not(:disabled) {
  background: #4c8ec2;
}
.footer-btn.secondary {
  background: #f4f6fb;
  color: #1f2937;
  border-color: #e0e7ff;
}
.footer-btn.secondary:hover:not(:disabled) {
  background: #e0e7ff;
}
.footer-btn.ghost {
  background: transparent;
  color: #5ea1d8;
  border-color: #5ea1d8;
}
.footer-btn.ghost:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.08);
}
.footer-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Blog step content */
.blog-wizard-step {
  text-align: left;
  width: 100%;
}

.cover-form-wrapper {
  background: #fff;
  max-width: 100%;
}
.cover-form-wrapper h3 {
  font-size: 14px;
  font-weight: 600;
  color: #030303;
  margin: 16px 0 8px;
  line-height: 20px;
  font-family: "Raleway", sans-serif;
}
.cover-form-wrapper h3.cam-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 0;
}
.cover-form-wrapper .example-form {
  margin-bottom: 0;
}

.blog-embed-section {
  margin-top: 24px;
}
.blog-embed-section h3 {
  font-size: 14px;
  font-weight: 600;
  color: #030303;
  margin: 0 0 8px;
  font-family: "Raleway", sans-serif;
}

.blog-embed-notice {
  margin: 0 0 12px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.4;
  color: #475569;
  background: #f1f5f9;
  border-left: 3px solid #5ea1d8;
  border-radius: 4px;
}

.blog-wizard-choice-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  margin: 8px 0 16px;
}

.blog-wizard-type-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 8px;
}

.blog-wizard-type-card {
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  color: #111827;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}
.blog-wizard-type-card .mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #5ea1d8;
}
.blog-wizard-type-card span {
  font-family: "Raleway", sans-serif;
  font-size: 15px;
  font-weight: 700;
}
.blog-wizard-type-card:hover {
  border-color: #5ea1d8;
}
.blog-wizard-type-card.selected {
  border-color: #5ea1d8;
  background: rgba(94, 161, 216, 0.08);
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.25);
}

.blog-embed-search {
  margin-top: 8px;
}

.blog-embed-search-form {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.blog-embed-search-form mat-form-field {
  flex: 1;
}
.blog-embed-search-form .footer-btn {
  margin-top: 4px;
}

.blog-embed-search-status {
  margin: 8px 0;
  color: #64748b;
  font-size: 14px;
}

.blog-embed-results {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0;
  max-height: 280px;
  overflow-y: auto;
}

.blog-embed-result {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
}
.blog-embed-result:hover {
  border-color: #5ea1d8;
}
.blog-embed-result.selected {
  border-color: #5ea1d8;
  background: rgba(94, 161, 216, 0.08);
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.2);
}

.blog-embed-result-thumb {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
  background: #f1f5f9;
}
.blog-embed-result-thumb.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}

.blog-embed-result-title {
  font-size: 14px;
  color: #212427;
  line-height: 1.3;
  font-weight: 600;
  word-break: break-word;
}

.blog-embed-settings {
  margin-top: 12px;
}

.blog-embed-field textarea {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  line-height: 1.5;
  min-height: 140px;
}

.blog-embed-preview {
  margin-top: 16px;
}
.blog-embed-preview label {
  display: block;
  margin-bottom: 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.blog-embed-preview-shell {
  width: 100%;
  padding: 12px;
  background: #f1f5f9;
  border-radius: 14px;
  box-sizing: border-box;
}

.blog-embed-preview-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 5/6;
  overflow: hidden;
  border-radius: 10px;
  background: #fff;
}
.blog-embed-preview-frame iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.blog-embed-summary {
  margin: 0 0 16px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border-left: 3px solid #5ea1d8;
}
.blog-embed-summary label {
  display: block;
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
}
.blog-embed-summary p {
  margin: 0 0 8px;
  font-size: 14px;
  color: #212427;
  font-weight: 600;
}

.table-wrapper {
  margin-bottom: 12px;
}
.table-wrapper .table-inner {
  border-radius: 12px;
  max-height: 260px;
  min-height: 160px;
  position: relative;
  overflow: hidden;
  border: 1px dashed #cbd5e1;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-wrapper .table-inner img.img-display {
  max-width: 100%;
  max-height: 240px;
  object-fit: contain;
}
.table-wrapper .table-inner .cover-placeholder {
  color: #64748b !important;
  padding: 16px;
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
}

.cover-upload-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 0 0 16px;
}
.cover-upload-row .file-name {
  font-size: 13px;
  color: #64748b;
}

.upload-icon-btn.fileExplorer {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  background: rgba(94, 161, 216, 0.1);
  color: #5ea1d8;
  border: 1px solid rgba(94, 161, 216, 0.35);
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  overflow: hidden;
}
.upload-icon-btn.fileExplorer mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #5ea1d8;
}
.upload-icon-btn.fileExplorer:hover {
  background: rgba(94, 161, 216, 0.16);
}

.hide_file {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.quill-wrapper {
  margin-bottom: 8px;
}
.quill-wrapper .blog-quill-editor {
  width: 100% !important;
  display: block;
}
.quill-wrapper ::ng-deep .ql-toolbar.ql-snow {
  border-radius: 10px 10px 0 0;
  border-color: #e2e8f0;
  background: #f8fafc;
}
.quill-wrapper ::ng-deep .ql-container.ql-snow {
  border-radius: 0 0 10px 10px;
  border-color: #e2e8f0;
  min-height: 160px;
}

.commonlintbtn-wrapper {
  margin-top: 8px;
}

.commonlintbtn-parent {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.clickable-text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #5ea1d8;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.clickable-text .material-icons {
  font-size: 18px;
  color: #5ea1d8;
}
.clickable-text:hover {
  text-decoration: underline;
}

.feature-toggle-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 16px 0 0;
}
.feature-toggle-row label {
  margin: 0;
  color: #111827 !important;
  font-size: 14px;
  font-weight: 600;
}

.w-100 {
  width: 100%;
}

.small-spinner img {
  width: 36px;
  height: 36px;
}

/* Mobile — match create-flow dialog behavior */
@media (max-width: 768px) {
  .upload-backdrop {
    padding: 0;
    align-items: stretch;
  }
  .upload-dialog {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
  .upload-header {
    padding: 8px 12px;
  }
  .upload-header .icon-circle {
    width: 42px;
    height: 42px;
  }
  .upload-header .header-copy .title {
    font-size: 16px;
  }
  .upload-header .header-copy span {
    font-size: 12px;
  }
  .stage-banner {
    padding: 0 10px 4px;
  }
  .journey-progress {
    padding-top: 10px;
  }
  .step-label {
    padding: 6px 12px;
    font-size: 11px;
  }
  .step-label .label-text {
    display: none;
  }
  .journey-content {
    padding: 16px;
  }
  .upload-footer {
    padding: 12px 14px;
    gap: 10px;
  }
  .footer-actions {
    width: 100%;
    justify-content: stretch;
  }
  .footer-actions .footer-btn {
    flex: 1 1 auto;
  }
  .blog-wizard-type-cards {
    grid-template-columns: 1fr;
  }
  .blog-embed-search-form {
    flex-direction: column;
  }
  .blog-embed-search-form .footer-btn {
    width: 100%;
    margin-top: 0;
  }
}
/* Dark mode — aligned with create-flow overlay treatment */
:host-context(body.theme-dark) .upload-dialog,
:host-context(body.theme-dark) .upload-header,
:host-context(body.theme-dark) .stage-banner,
:host-context(body.theme-dark) .upload-footer,
:host-context(body.theme-dark) .section-card.journey-card,
:host-context(body.theme-dark) .cover-form-wrapper {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-body,
:host-context(body.theme-dark) .journey-content {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .header-copy .title,
:host-context(body.theme-dark) .journey-pane-header h3,
:host-context(body.theme-dark) .cover-form-wrapper h3,
:host-context(body.theme-dark) .blog-embed-section h3,
:host-context(body.theme-dark) .blog-embed-result-title,
:host-context(body.theme-dark) .blog-embed-summary p,
:host-context(body.theme-dark) .feature-toggle-row label {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .header-copy span,
:host-context(body.theme-dark) .helper-text,
:host-context(body.theme-dark) .blog-embed-search-status,
:host-context(body.theme-dark) .blog-embed-preview label,
:host-context(body.theme-dark) .blog-embed-summary label,
:host-context(body.theme-dark) .cover-placeholder,
:host-context(body.theme-dark) .file-name {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .icon-circle {
  background: rgba(94, 161, 216, 0.18) !important;
}
:host-context(body.theme-dark) .icon-button {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .journey-step:not(.active):not(.complete) {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .step-connector {
  background: #374151 !important;
}
:host-context(body.theme-dark) .blog-wizard-type-card,
:host-context(body.theme-dark) .blog-embed-result,
:host-context(body.theme-dark) .blog-embed-summary,
:host-context(body.theme-dark) .blog-embed-preview-shell,
:host-context(body.theme-dark) .blog-embed-preview-frame,
:host-context(body.theme-dark) .table-wrapper .table-inner {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .blog-wizard-type-card.selected,
:host-context(body.theme-dark) .blog-embed-result.selected {
  background: rgba(94, 161, 216, 0.14) !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .blog-embed-notice {
  background: rgba(94, 161, 216, 0.14) !important;
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-icon-btn.fileExplorer {
  background: rgba(94, 161, 216, 0.16) !important;
  border-color: rgba(94, 161, 216, 0.45) !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .upload-icon-btn.fileExplorer mat-icon {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .upload-progress {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .footer-btn.secondary {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .footer-btn.ghost {
  color: #93c5fd !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .footer-btn.primary {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .clickable-text,
:host-context(body.theme-dark) .clickable-text .material-icons {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) ::ng-deep .mdc-text-field,
:host-context(body.theme-dark) ::ng-deep .ql-toolbar.ql-snow,
:host-context(body.theme-dark) ::ng-deep .ql-container.ql-snow {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-label,
:host-context(body.theme-dark) ::ng-deep .mdc-floating-label,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-hint,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-subscript-wrapper,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-label,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-slide-toggle .mdc-label {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-input-element,
:host-context(body.theme-dark) ::ng-deep .ql-editor,
:host-context(body.theme-dark) ::ng-deep .ql-editor.ql-blank::before {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) ::ng-deep .ql-toolbar.ql-snow .ql-stroke {
  stroke: #cbd5e1 !important;
}
:host-context(body.theme-dark) ::ng-deep .ql-toolbar.ql-snow .ql-fill {
  fill: #cbd5e1 !important;
}
:host-context(body.theme-dark) ::ng-deep .ql-toolbar.ql-snow .ql-picker {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-chip,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-chip-row {
  background: #334155 !important;
  color: #f8fafc !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-chip-remove,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-chip-remove mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-radio__outer-circle,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-radio__inner-circle {
  border-color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button.mat-mdc-radio-checked .mdc-radio__outer-circle,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button.mat-mdc-radio-checked .mdc-radio__inner-circle {
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-slide-toggle .mdc-switch__track::before {
  background: #475569 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/create-blog/create-blog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;iEAAA;AAMA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AADF;;AAIA;EACE,UAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AADF;AAGE;EACE,cArEM;EAsEN,eAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAKA;EACE,YAAA;AAFF;AAIE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAFJ;AAKE;EACE,eAAA;EACA,cAAA;AAHJ;;AAOA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;AAJF;AAME;EACE,eAAA;AAJJ;AAOE;EACE,mBAAA;EACA,2BAAA;AALJ;;AASA;EACE,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AANF;;AASA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AANF;AAQE;EACE,aAAA;EACA,mBAAA;AANJ;;AAUA;EACE,cA/JQ;AAwJV;AASE;EACE,qBAlKM;EAmKN,mCAAA;EACA,cApKM;AA6JV;;AAWA;EACE,cAAA;AARF;AAUE;EACE,qBAAA;EACA,kCAAA;EACA,cAAA;AARJ;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,kCAAA;AATF;AAWE;;EAEE,oBAAA;EACA,mBAAA;EACA,mBAAA;AATJ;AAYE;EACE,qBAAA;EACA,cAAA;EACA,kCAAA;AAVJ;AAaE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAXJ;;AAeA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAZF;AAcE;EACE,UAAA;AAZJ;AAeE;EACE,mBAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,mBAAA;AAdN;;AAmBA;EACE,cAAA;EACA,YAAA;AAhBF;AAkBE;EACE,WAAA;AAhBJ;;AAoBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;AAmBE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAjBJ;;AAqBA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;EACA,cAAA;AAlBF;AAoBE;EACE,cAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,oBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,kCAAA;AAnBF;AAqBE;EACE,mBA/VM;EAgWN,WAAA;EACA,qBAjWM;AA8UV;AAqBI;EACE,mBAAA;AAnBN;AAuBE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AArBJ;AAuBI;EACE,mBAAA;AArBN;AAyBE;EACE,uBAAA;EACA,cApXM;EAqXN,qBArXM;AA8VV;AAyBI;EACE,oCAAA;AAvBN;AA2BE;EACE,YAAA;EACA,mBAAA;AAzBJ;;AA6BA,sBAAA;AACA;EACE,gBAAA;EACA,WAAA;AA1BF;;AA6BA;EACE,gBAAA;EACA,eAAA;AA1BF;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;AA1BJ;AA4BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;AA1BN;AA8BE;EACE,gBAAA;AA5BJ;;AAgCA;EACE,gBAAA;AA7BF;AA+BE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;AA7BJ;;AAiCA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iFAAA;AA9BF;AAgCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAxdM;AA0bV;AAiCE;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;AA/BJ;AAkCE;EACE,qBAleM;AAkcV;AAmCE;EACE,qBAteM;EAueN,oCAAA;EACA,8CAAA;AAjCJ;;AAqCA;EACE,eAAA;AAlCF;;AAqCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAlCF;AAoCE;EACE,OAAA;AAlCJ;AAqCE;EACE,eAAA;AAnCJ;;AAuCA;EACE,aAAA;EACA,cAAA;EACA,eAAA;AApCF;;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AApCF;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AApCF;AAsCE;EACE,qBA1hBM;AAsfV;AAuCE;EACE,qBA9hBM;EA+hBN,oCAAA;EACA,6CAAA;AArCJ;;AAyCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAtCF;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAtCJ;;AA0CA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAvCF;;AA0CA;EACE,gBAAA;AAvCF;;AA0CA;EACE,6EAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAvCF;;AA0CA;EACE,gBAAA;AAvCF;AAyCE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAvCJ;;AA2CA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAxCF;AA0CE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAxCJ;;AA4CA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAzCF;AA2CE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAzCJ;AA4CE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA1CJ;;AA8CA;EACE,mBAAA;AA3CF;AA6CE;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3CJ;AA6CI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AA3CN;AA8CI;EACE,yBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AA5CN;;AAiDA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AA9CF;AAgDE;EACE,eAAA;EACA,cAAA;AA9CJ;;AAkDA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,cA5rBQ;EA6rBR,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA/CF;AAiDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAvsBM;AAwpBV;AAkDE;EACE,oCAAA;AAhDJ;;AAoDA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAjDF;;AAoDA;EACE,kBAAA;AAjDF;AAmDE;EACE,sBAAA;EACA,cAAA;AAjDJ;AAqDI;EACE,4BAAA;EACA,qBAAA;EACA,mBAAA;AAnDN;AAsDI;EACE,4BAAA;EACA,qBAAA;EACA,iBAAA;AApDN;;AAyDA;EACE,eAAA;AAtDF;;AAyDA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAtDF;;AAyDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cA9vBQ;EA+vBR,eAAA;EACA,gBAAA;EACA,eAAA;AAtDF;AAwDE;EACE,eAAA;EACA,cArwBM;AA+sBV;AAyDE;EACE,0BAAA;AAvDJ;;AA2DA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAxDF;AA0DE;EACE,SAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAxDJ;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;EACA,YAAA;AAzDF;;AA4DA,+CAAA;AACA;EACE;IACE,UAAA;IACA,oBAAA;EAzDF;EA4DA;IACE,WAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;EA1DF;EA6DA;IACE,iBAAA;EA3DF;EA6DE;IACE,WAAA;IACA,YAAA;EA3DJ;EA8DE;IACE,eAAA;EA5DJ;EA+DE;IACE,eAAA;EA7DJ;EAiEA;IACE,mBAAA;EA/DF;EAkEA;IACE,iBAAA;EAhEF;EAmEA;IACE,iBAAA;IACA,eAAA;EAjEF;EAoEA;IACE,aAAA;EAlEF;EAqEA;IACE,aAAA;EAnEF;EAsEA;IACE,kBAAA;IACA,SAAA;EApEF;EAuEA;IACE,WAAA;IACA,wBAAA;EArEF;EAuEE;IACE,cAAA;EArEJ;EAyEA;IACE,0BAAA;EAvEF;EA0EA;IACE,sBAAA;EAxEF;EA0EE;IACE,WAAA;IACA,aAAA;EAxEJ;AACF;AA4EA,2DAAA;AAEE;;;;;;EAME,8BAAA;EACA,yBAAA;EACA,kDAAA;AA3EJ;AA8EE;;EAEE,8BAAA;AA5EJ;AA+EE;;;;;;;EAOE,yBAAA;AA7EJ;AAgFE;;;;;;;EAOE,yBAAA;AA9EJ;AAiFE;EACE,+CAAA;AA/EJ;AAkFE;EACE,8BAAA;EACA,yBAAA;AAhFJ;AAmFE;EACE,yBAAA;AAjFJ;AAoFE;EACE,8BAAA;AAlFJ;AAqFE;;;;;;EAME,8BAAA;EACA,iDAAA;EACA,yBAAA;AAnFJ;AAsFE;;EAEE,+CAAA;EACA,gCAAA;AApFJ;AAuFE;EACE,+CAAA;EACA,yBAAA;AArFJ;AAwFE;EACE,+CAAA;EACA,iDAAA;EACA,yBAAA;AAtFJ;AAwFI;EACE,yBAAA;AAtFN;AA0FE;EACE,yBAAA;AAxFJ;AA2FE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAzFJ;AA4FE;EACE,yBAAA;EACA,gCAAA;AA1FJ;AA6FE;EACE,yBAAA;AA3FJ;AA8FE;;EAEE,yBAAA;AA5FJ;AAgGI;;;;EAIE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA9FN;AAiGI;;;;;;EAME,yBAAA;AA/FN;AAkGI;;;EAGE,yBAAA;AAhGN;AAmGI;EACE,0BAAA;AAjGN;AAoGI;EACE,wBAAA;AAlGN;AAqGI;EACE,yBAAA;AAnGN;AAsGI;;EAEE,8BAAA;EACA,yBAAA;AApGN;AAuGI;;EAEE,yBAAA;AArGN;AAwGI;;EAEE,gCAAA;AAtGN;AAyGI;;EAEE,gCAAA;AAvGN;AA0GI;EACE,8BAAA;AAxGN","sourcesContent":["/* ============================================================\n   Create Blog — styled to match create-flow (upload-dialog shell)\n   ============================================================ */\n\n$fc-blue: #5ea1d8;\n\n.upload-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  overflow: hidden;\n}\n\n.upload-dialog {\n  width: 90%;\n  max-width: 980px;\n  height: 90vh;\n  max-height: 90vh;\n  background: #fff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: auto;\n  z-index: 10000;\n}\n\n.upload-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: #fff;\n  color: #111827;\n  border-bottom: 1px solid #e4e8f0;\n  flex-shrink: 0;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  min-width: 0;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.icon-circle {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  mat-icon {\n    color: $fc-blue;\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.header-copy {\n  min-width: 0;\n\n  .title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n    font-family: \"Raleway\", sans-serif;\n  }\n\n  span {\n    font-size: 14px;\n    color: #6b7280;\n  }\n}\n\n.icon-button {\n  border: none;\n  background: #f3f4f6;\n  color: inherit;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n\n  mat-icon {\n    font-size: 22px;\n  }\n\n  &:hover {\n    background: #e5e7eb;\n    transform: translateY(-1px);\n  }\n}\n\n.stage-banner {\n  padding: 1px 16px 8px;\n  background: #fff;\n  border-bottom: 1px solid #edf1f7;\n  flex-shrink: 0;\n}\n\n.journey-progress {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  padding: 16px 0 8px;\n  margin-top: 4px;\n  flex-shrink: 0;\n  overflow-x: auto;\n  flex-wrap: nowrap;\n  width: 100%;\n  position: relative;\n}\n\n.journey-step {\n  background: transparent;\n  border: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n  min-width: auto;\n  flex-shrink: 0;\n  cursor: pointer;\n  color: #9ca3af;\n  transition: color 0.2s ease;\n  white-space: nowrap;\n  align-self: center;\n  padding: 0;\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.journey-step.active {\n  color: $fc-blue;\n\n  .step-label {\n    border-color: $fc-blue;\n    background: rgba(94, 161, 216, 0.1);\n    color: $fc-blue;\n  }\n}\n\n.journey-step.complete {\n  color: #16a34a;\n\n  .step-label {\n    border-color: #16a34a;\n    background: rgba(22, 163, 74, 0.1);\n    color: #16a34a;\n  }\n}\n\n.step-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.2;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 8px 16px;\n  border-radius: 35px;\n  border: 2px solid currentColor;\n  background: transparent;\n  flex-shrink: 0;\n  font-family: \"Raleway\", sans-serif;\n\n  .step-count,\n  .label-text {\n    display: inline-flex;\n    align-items: center;\n    white-space: nowrap;\n  }\n\n  &.complete {\n    border-color: #16a34a;\n    color: #16a34a;\n    background: rgba(22, 163, 74, 0.1);\n  }\n\n  .label-check {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    margin-left: 0.15rem;\n  }\n}\n\n.step-connector {\n  flex: 1;\n  min-width: 20px;\n  height: 2px;\n  background: #e5e7eb;\n  flex-shrink: 1;\n  align-self: center;\n  margin: 0 4px;\n  position: relative;\n  z-index: 0;\n}\n\n.step-connector.fill {\n  background: #16a34a;\n}\n\n.upload-body {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  padding: 10px;\n  background: #fdfdff;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  flex: 1 1 auto;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n\n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n.primary-pane {\n  flex: 1 1 100%;\n  min-width: 0;\n\n  &.full-width {\n    width: 100%;\n  }\n}\n\n.section-card.journey-card {\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #e4e8f0;\n  overflow: hidden;\n  min-height: 100%;\n}\n\n.journey-content {\n  padding: 24px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1 1 0;\n  min-height: 0;\n}\n\n.journey-pane-header {\n  margin-bottom: 16px;\n\n  h3 {\n    margin: 0 0 6px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #111827;\n    font-family: \"Raleway\", sans-serif;\n  }\n}\n\n.helper-text {\n  margin: 0;\n  color: #5f6368;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.upload-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #e4e8f0;\n  background: #fff;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.05);\n  flex-shrink: 0;\n\n  .footer-step {\n    flex: 0 0 auto;\n  }\n}\n\n.footer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 1 1 auto;\n}\n\n.footer-btn {\n  border-radius: 999px;\n  border: 1px solid transparent;\n  padding: 10px 24px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  white-space: nowrap;\n  font-family: \"Raleway\", sans-serif;\n\n  &.primary {\n    background: $fc-blue;\n    color: #fff;\n    border-color: $fc-blue;\n\n    &:hover:not(:disabled) {\n      background: #4c8ec2;\n    }\n  }\n\n  &.secondary {\n    background: #f4f6fb;\n    color: #1f2937;\n    border-color: #e0e7ff;\n\n    &:hover:not(:disabled) {\n      background: #e0e7ff;\n    }\n  }\n\n  &.ghost {\n    background: transparent;\n    color: $fc-blue;\n    border-color: $fc-blue;\n\n    &:hover:not(:disabled) {\n      background: rgba(94, 161, 216, 0.08);\n    }\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n/* Blog step content */\n.blog-wizard-step {\n  text-align: left;\n  width: 100%;\n}\n\n.cover-form-wrapper {\n  background: #fff;\n  max-width: 100%;\n\n  h3 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #030303;\n    margin: 16px 0 8px;\n    line-height: 20px;\n    font-family: \"Raleway\", sans-serif;\n\n    &.cam-icon {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-top: 0;\n    }\n  }\n\n  .example-form {\n    margin-bottom: 0;\n  }\n}\n\n.blog-embed-section {\n  margin-top: 24px;\n\n  h3 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #030303;\n    margin: 0 0 8px;\n    font-family: \"Raleway\", sans-serif;\n  }\n}\n\n.blog-embed-notice {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #475569;\n  background: #f1f5f9;\n  border-left: 3px solid $fc-blue;\n  border-radius: 4px;\n}\n\n.blog-wizard-choice-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.5rem;\n  margin: 8px 0 16px;\n}\n\n.blog-wizard-type-cards {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.blog-wizard-type-card {\n  min-height: 120px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border: 2px solid #e2e8f0;\n  border-radius: 14px;\n  background: #fff;\n  cursor: pointer;\n  color: #111827;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n\n  .mat-icon {\n    font-size: 32px;\n    width: 32px;\n    height: 32px;\n    color: $fc-blue;\n  }\n\n  span {\n    font-family: \"Raleway\", sans-serif;\n    font-size: 15px;\n    font-weight: 700;\n  }\n\n  &:hover {\n    border-color: $fc-blue;\n  }\n\n  &.selected {\n    border-color: $fc-blue;\n    background: rgba(94, 161, 216, 0.08);\n    box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.25);\n  }\n}\n\n.blog-embed-search {\n  margin-top: 8px;\n}\n\n.blog-embed-search-form {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n\n  mat-form-field {\n    flex: 1;\n  }\n\n  .footer-btn {\n    margin-top: 4px;\n  }\n}\n\n.blog-embed-search-status {\n  margin: 8px 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.blog-embed-results {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 12px 0;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.blog-embed-result {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  padding: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n\n  &:hover {\n    border-color: $fc-blue;\n  }\n\n  &.selected {\n    border-color: $fc-blue;\n    background: rgba(94, 161, 216, 0.08);\n    box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.2);\n  }\n}\n\n.blog-embed-result-thumb {\n  width: 56px;\n  height: 56px;\n  object-fit: cover;\n  border-radius: 8px;\n  flex-shrink: 0;\n  background: #f1f5f9;\n\n  &.placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #94a3b8;\n  }\n}\n\n.blog-embed-result-title {\n  font-size: 14px;\n  color: #212427;\n  line-height: 1.3;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.blog-embed-settings {\n  margin-top: 12px;\n}\n\n.blog-embed-field textarea {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  line-height: 1.5;\n  min-height: 140px;\n}\n\n.blog-embed-preview {\n  margin-top: 16px;\n\n  label {\n    display: block;\n    margin-bottom: 8px;\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n}\n\n.blog-embed-preview-shell {\n  width: 100%;\n  padding: 12px;\n  background: #f1f5f9;\n  border-radius: 14px;\n  box-sizing: border-box;\n}\n\n.blog-embed-preview-frame {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 5 / 6;\n  overflow: hidden;\n  border-radius: 10px;\n  background: #fff;\n\n  iframe {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n    display: block;\n  }\n}\n\n.blog-embed-summary {\n  margin: 0 0 16px;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border-left: 3px solid $fc-blue;\n\n  label {\n    display: block;\n    font-size: 12px;\n    color: #64748b;\n    margin-bottom: 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    font-weight: 700;\n  }\n\n  p {\n    margin: 0 0 8px;\n    font-size: 14px;\n    color: #212427;\n    font-weight: 600;\n  }\n}\n\n.table-wrapper {\n  margin-bottom: 12px;\n\n  .table-inner {\n    border-radius: 12px;\n    max-height: 260px;\n    min-height: 160px;\n    position: relative;\n    overflow: hidden;\n    border: 1px dashed #cbd5e1;\n    background: #f8fafc;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img.img-display {\n      max-width: 100%;\n      max-height: 240px;\n      object-fit: contain;\n    }\n\n    .cover-placeholder {\n      color: #64748b !important;\n      padding: 16px;\n      margin: 0;\n      font-size: 14px;\n      line-height: 1.45;\n    }\n  }\n}\n\n.cover-upload-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin: 0 0 16px;\n\n  .file-name {\n    font-size: 13px;\n    color: #64748b;\n  }\n}\n\n.upload-icon-btn.fileExplorer {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 10px;\n  background: rgba(94, 161, 216, 0.1);\n  color: $fc-blue;\n  border: 1px solid rgba(94, 161, 216, 0.35);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  overflow: hidden;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: $fc-blue;\n  }\n\n  &:hover {\n    background: rgba(94, 161, 216, 0.16);\n  }\n}\n\n.hide_file {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.quill-wrapper {\n  margin-bottom: 8px;\n\n  .blog-quill-editor {\n    width: 100% !important;\n    display: block;\n  }\n\n  ::ng-deep {\n    .ql-toolbar.ql-snow {\n      border-radius: 10px 10px 0 0;\n      border-color: #e2e8f0;\n      background: #f8fafc;\n    }\n\n    .ql-container.ql-snow {\n      border-radius: 0 0 10px 10px;\n      border-color: #e2e8f0;\n      min-height: 160px;\n    }\n  }\n}\n\n.commonlintbtn-wrapper {\n  margin-top: 8px;\n}\n\n.commonlintbtn-parent {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.clickable-text {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: $fc-blue;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n\n  .material-icons {\n    font-size: 18px;\n    color: $fc-blue;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.feature-toggle-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 16px 0 0;\n\n  label {\n    margin: 0;\n    color: #111827 !important;\n    font-size: 14px;\n    font-weight: 600;\n  }\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.small-spinner img {\n  width: 36px;\n  height: 36px;\n}\n\n/* Mobile — match create-flow dialog behavior */\n@media (max-width: 768px) {\n  .upload-backdrop {\n    padding: 0;\n    align-items: stretch;\n  }\n\n  .upload-dialog {\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: 100%;\n    border-radius: 0;\n  }\n\n  .upload-header {\n    padding: 8px 12px;\n\n    .icon-circle {\n      width: 42px;\n      height: 42px;\n    }\n\n    .header-copy .title {\n      font-size: 16px;\n    }\n\n    .header-copy span {\n      font-size: 12px;\n    }\n  }\n\n  .stage-banner {\n    padding: 0 10px 4px;\n  }\n\n  .journey-progress {\n    padding-top: 10px;\n  }\n\n  .step-label {\n    padding: 6px 12px;\n    font-size: 11px;\n  }\n\n  .step-label .label-text {\n    display: none;\n  }\n\n  .journey-content {\n    padding: 16px;\n  }\n\n  .upload-footer {\n    padding: 12px 14px;\n    gap: 10px;\n  }\n\n  .footer-actions {\n    width: 100%;\n    justify-content: stretch;\n\n    .footer-btn {\n      flex: 1 1 auto;\n    }\n  }\n\n  .blog-wizard-type-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .blog-embed-search-form {\n    flex-direction: column;\n\n    .footer-btn {\n      width: 100%;\n      margin-top: 0;\n    }\n  }\n}\n\n/* Dark mode — aligned with create-flow overlay treatment */\n:host-context(body.theme-dark) {\n  .upload-dialog,\n  .upload-header,\n  .stage-banner,\n  .upload-footer,\n  .section-card.journey-card,\n  .cover-form-wrapper {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-body,\n  .journey-content {\n    background: #0f172a !important;\n  }\n\n  .header-copy .title,\n  .journey-pane-header h3,\n  .cover-form-wrapper h3,\n  .blog-embed-section h3,\n  .blog-embed-result-title,\n  .blog-embed-summary p,\n  .feature-toggle-row label {\n    color: #f8fafc !important;\n  }\n\n  .header-copy span,\n  .helper-text,\n  .blog-embed-search-status,\n  .blog-embed-preview label,\n  .blog-embed-summary label,\n  .cover-placeholder,\n  .file-name {\n    color: #94a3b8 !important;\n  }\n\n  .icon-circle {\n    background: rgba(94, 161, 216, 0.18) !important;\n  }\n\n  .icon-button {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .journey-step:not(.active):not(.complete) {\n    color: #94a3b8 !important;\n  }\n\n  .step-connector {\n    background: #374151 !important;\n  }\n\n  .blog-wizard-type-card,\n  .blog-embed-result,\n  .blog-embed-summary,\n  .blog-embed-preview-shell,\n  .blog-embed-preview-frame,\n  .table-wrapper .table-inner {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .blog-wizard-type-card.selected,\n  .blog-embed-result.selected {\n    background: rgba(94, 161, 216, 0.14) !important;\n    border-color: $fc-blue !important;\n  }\n\n  .blog-embed-notice {\n    background: rgba(94, 161, 216, 0.14) !important;\n    color: #cbd5e1 !important;\n  }\n\n  .upload-icon-btn.fileExplorer {\n    background: rgba(94, 161, 216, 0.16) !important;\n    border-color: rgba(94, 161, 216, 0.45) !important;\n    color: #93c5fd !important;\n\n    mat-icon {\n      color: #93c5fd !important;\n    }\n  }\n\n  .upload-progress {\n    color: #cbd5e1 !important;\n  }\n\n  .footer-btn.secondary {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .footer-btn.ghost {\n    color: #93c5fd !important;\n    border-color: $fc-blue !important;\n  }\n\n  .footer-btn.primary {\n    color: #ffffff !important;\n  }\n\n  .clickable-text,\n  .clickable-text .material-icons {\n    color: #93c5fd !important;\n  }\n\n  ::ng-deep {\n    .mat-mdc-text-field-wrapper,\n    .mdc-text-field,\n    .ql-toolbar.ql-snow,\n    .ql-container.ql-snow {\n      background: #1f2937 !important;\n      color: #e2e8f0 !important;\n      border-color: rgba(148, 163, 184, 0.35) !important;\n    }\n\n    .mat-mdc-form-field-label,\n    .mdc-floating-label,\n    .mat-mdc-form-field-hint,\n    .mat-mdc-form-field-subscript-wrapper,\n    .mat-mdc-radio-button .mdc-label,\n    .mat-mdc-slide-toggle .mdc-label {\n      color: #cbd5e1 !important;\n    }\n\n    .mat-mdc-input-element,\n    .ql-editor,\n    .ql-editor.ql-blank::before {\n      color: #f8fafc !important;\n    }\n\n    .ql-toolbar.ql-snow .ql-stroke {\n      stroke: #cbd5e1 !important;\n    }\n\n    .ql-toolbar.ql-snow .ql-fill {\n      fill: #cbd5e1 !important;\n    }\n\n    .ql-toolbar.ql-snow .ql-picker {\n      color: #e2e8f0 !important;\n    }\n\n    .mat-mdc-chip,\n    .mat-mdc-chip-row {\n      background: #334155 !important;\n      color: #f8fafc !important;\n    }\n\n    .mat-mdc-chip-remove,\n    .mat-mdc-chip-remove mat-icon {\n      color: #94a3b8 !important;\n    }\n\n    .mat-mdc-radio-button .mdc-radio__outer-circle,\n    .mat-mdc-radio-button .mdc-radio__inner-circle {\n      border-color: #94a3b8 !important;\n    }\n\n    .mat-mdc-radio-button.mat-mdc-radio-checked .mdc-radio__outer-circle,\n    .mat-mdc-radio-button.mat-mdc-radio-checked .mdc-radio__inner-circle {\n      border-color: $fc-blue !important;\n    }\n\n    .mat-mdc-slide-toggle .mdc-switch__track::before {\n      background: #475569 !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
